import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './mail.module.scss';
import SimpleMail from './simpleMail';
import SimpleMinimizedMail from './simpleMinimizedMail';
import ComposedMail from './composedMail';
import ComposedMinimizedMail from './composedMinimizedMail';

class Mail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMail: this.getMailShownFlag(props.actionThread),    //Get mail shown flag to display reply emails 
            shouldMinimizeMail: props.lastMail.id !== props.id,
            shouldMinimizeReply: props.lastMail.id !== props.id
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.props.lastMail !== nextProps.lastMail) {
            this.setState({
                showMail: this.getMailShownFlag(nextProps.actionThread),
                shouldMinimizeMail: nextProps.lastMail.id !== nextProps.id,
                shouldMinimizeReply: nextProps.lastMail.id !== nextProps.id
            });
        }
    }

    checkForMailResponse = (type, actionThread) => {
        return type === "compose" && actionThread && actionThread.some((action) => action.type === "compose")
    }

    toggleDisplayForPrimaryMail = () => {
        this.setState({
            shouldMinimizeMail: false
        })
    }

    toggleDisplayForReplyMail = () => {
        this.setState({
            shouldMinimizeReply: false
        })
    }

    getNextMailId = (actionThread) => {
        return actionThread.find(action => action.type === "next_mail").mailId
    }

    getMailShownFlag = (actionThread) => {
        return actionThread.some(action => action.type === "isShown")
    }

    getFromActor = () => {
        const { from, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
        if (actorDetails) {
            return actorDetails.first_name + ' ' + actorDetails.last_name
        }
        return from;
    }

    getToActors = () => {
        const { to, actors } = this.props;
        let temp, actorArray = [];
        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)

                if (temp) {
                    actorArray.push(temp.first_name + ' ' + temp.last_name)
                } else {
                    return actorArray.push(toActor);
                }
            })

            return actorArray.join(", ");
        }
    }

    render() {
        const { type, actionThread, actors, receivedAtTime, currentTime, showButtons, selfActor } = this.props;
        const { showMail, shouldMinimizeMail, shouldMinimizeReply } = this.state;

        let displayTime = Math.floor((receivedAtTime - currentTime) / 60);
        if (!(displayTime > 0)) {
            displayTime = 0;
        }

        return <React.Fragment>
            {
                showMail ?
                    <div className={styles["primary-mail"]}>
                        {
                            shouldMinimizeMail ?
                                <SimpleMinimizedMail
                                    {...this.props}
                                    showReplyOption={!this.checkForMailResponse(type, actionThread) && type === "compose"}
                                    onMailClick={this.toggleDisplayForPrimaryMail}
                                    displayTime={displayTime}
                                    showButtons={showButtons}
                                />
                                :
                                <SimpleMail
                                    {...this.props}
                                    actors={actors}
                                    showReplyOption={!this.checkForMailResponse(type, actionThread) && type === "compose"}
                                    getTimeData={this.props.getTimeData}
                                    autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
                                    setSurveyCompleteFlag={this.props.setSurveyCompleteFlag}
                                    displayTime={displayTime}
                                    showButtons={showButtons}
                                    startCall={this.props.startCall}
                                    isCallCompleted={this.props.isCallCompleted}
                                    addMailStarredFlag={this.props.addMailStarredFlag}
                                    removeMailStarredFlag={this.props.removeMailStarredFlag}
                                    tutorial={this.props.tutorial}
                                    startTutorial={this.props.startTutorial}
                                    stopTutorial={this.props.stopTutorial}
                                    addStepsToTutorial={this.props.addStepsToTutorial}
                                    updateStepNumber={this.props.updateStepNumber}
                                    //for displaying actor details on hover
                                    getActorDetailsOnHover={this.props.getActorDetailsOnHover}
                                    setIsHoveredFlag={this.props.setIsHoveredFlag}
                                    removeIsHoveredFlag={this.props.removeIsHoveredFlag}
                                    isHovered={this.props.isHovered}
                                    currentActorId={this.props.currentActorId}
                                />
                        }
                    </div>
                    :
                    null
            }
            {
                this.checkForMailResponse(type, actionThread) ?
                    <div className={styles["composed-mail"]}>
                        {
                            shouldMinimizeReply ?
                                <ComposedMinimizedMail
                                    {...this.props}
                                    onMailClick={this.toggleDisplayForReplyMail}
                                    currentTime={currentTime}
                                    selfActor={selfActor}
                                />
                                :
                                <ComposedMail
                                    {...this.props}
                                    actors={actors}
                                    currentTime={currentTime}
                                    //for displaying actor details on hover
                                    getActorDetailsOnHover={this.props.getActorDetailsOnHover}
                                    setIsHoveredFlag={this.props.setIsHoveredFlag}
                                    removeIsHoveredFlag={this.props.removeIsHoveredFlag}
                                    isHovered={this.props.isHovered}
                                    currentActorId={this.props.currentActorId}
                                    selfActor={selfActor}
                                />
                        }
                    </div>
                    :
                    null
            }
        </React.Fragment>;
    }

}
Mail.propTypes = {

}

Mail.defaultProps = {

}

export default Mail;


// WEBPACK FOOTER //
// /src/components/mailThread/mail/Mail.js